import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllCompanies } from '../../../api/redux/slices/Customer';
import { LoaderComponent } from '../../../helpers/components/loader';
import {
	BsBuilding,
	BsTelephone,
	BsEnvelope,
	BsGeoAlt,
	BsArrowRight,
	BsSearch,
} from 'react-icons/bs';
import './companies.scss';

const getInitials = (name = '') =>
	name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase();

const Companies = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const token = localStorage.getItem('accesstoken');
	const { allCompaniesList, loading } = useSelector((state) => state.customer);
	const [companies, setCompanies] = useState([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		if (token) dispatch(getAllCompanies({ token }));
	}, [dispatch, token]);

	useEffect(() => {
		if (allCompaniesList) setCompanies(allCompaniesList);
	}, [allCompaniesList]);

	const filtered = companies.filter((c) =>
		(c.name || '').toLowerCase().includes(search.toLowerCase())
	);

	if (loading) return <LoaderComponent />;

	return (
		<div className='companies-page'>
			<div className='companies-header'>
				<div className='header-left'>
					<h1>Sociétés <span>partenaires</span></h1>
					<p>Découvrez notre réseau de sociétés innovantes</p>
				</div>
				<div className='header-right'>
					<div className='search-box'>
						<BsSearch />
						<input
							type='text'
							placeholder='Rechercher une société...'
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
					</div>
					<div className='stat-badge'>
						<BsBuilding />
						<span className='badge-num'>{companies.length}</span>
						<span>Sociétés</span>
					</div>
				</div>
			</div>

			<div className='companies-container'>
				<div className='companies-grid'>
					{filtered.map((company) => {
						const imgUrl = company?.image?.secure_url || null;
						const initials = getInitials(company.name);

						return (
							<div
								key={company._id}
								className='company-card'
								onClick={() => navigate(`/client/company/${company._id}`)}
							>
								{/* Big image on top */}
								<div className='card-image-wrap'>
									{imgUrl ? (
										<img
											className='card-img'
											src={imgUrl}
											alt={company.name}
											onError={(e) => {
												e.target.style.display = 'none';
												e.target.nextSibling.style.display = 'flex';
											}}
										/>
									) : null}
									<span
										className='logo-initials'
										style={{ display: imgUrl ? 'none' : 'flex' }}
									>
										{initials || <BsBuilding className='logo-icon' />}
									</span>
								</div>

								<div className='card-body'>
									<h3 className='company-name'>{company.name || 'Société'}</h3>

									<div className='company-meta'>
										{company.email && (
											<div className='meta-item'>
												<BsEnvelope />
												<span>{company.email}</span>
											</div>
										)}
										{company.phone && (
											<div className='meta-item'>
												<BsTelephone />
												<span>{company.phone}</span>
											</div>
										)}
										{company.address && (
											<div className='meta-item'>
												<BsGeoAlt />
												<span>{company.address}</span>
											</div>
										)}
									</div>

									<button className='btn-view'>
										<span>Voir le profil</span>
										<BsArrowRight />
									</button>
								</div>
							</div>
						);
					})}
				</div>

				{filtered.length === 0 && !loading && (
					<div className='no-companies'>
						<BsBuilding />
						<p>{search ? `Aucun résultat pour "${search}"` : 'Aucune société trouvée'}</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default Companies;